import React from "react";

import { useTranslation } from "utils";

import { MODULE_COUNT } from "consts";

import { Icon, ModuleIconStatus, Typography } from "components";

type ModuleIconStatusPanelProps = {
  alignRight?: boolean;
  locked?: boolean;
  icons: { icon: string }[];
};

export const ModuleIconStatusPanel = ({ alignRight, locked, icons }: ModuleIconStatusPanelProps) => {
  const { t } = useTranslation("modules");

  const getPanel = () => {
    if (locked) {
      return (
        <div className="unlock">
          <Icon iconName="tabler/lock" className="icon inline margin-right-25" />
          <Typography variant="paragraph-m">{t("moduleIconStatus.unlock")}</Typography>
        </div>
      );
    }

    if (!icons?.length) {
      return <Typography variant="paragraph-xs">{t("moduleIconStatus.noModules")}</Typography>;
    }

    return icons
      .filter((icon) => !!icon)
      .map((icon, i) => (
        <ModuleIconStatus
          {...icon}
          key={i}
          style={{
            transform: `translateX(-${i + 0.5}rem)`,
          }}
        />
      ));
  };

  return (
    <div className="module-icon-status-panel" style={{ marginRight: alignRight ? `${(MODULE_COUNT - icons.length - 1) * -1.5}rem` : 0 }}>
      {getPanel()}
    </div>
  );
};
